import React from "react"
import { Route, Switch, BrowserRouter as Router } from "react-router-dom"
import { CssBaseline } from "@material-ui/core"
import Themeify from "./utils/Themeify"
import Login from "./pages/account/Login"
import AppShell from "./pages/shell/AppShell"

export default function App() {
  return (
    <div>
      <Router>
        <Themeify>
          <Switch>
            <Route path="/login"><Login /></Route>
            <Route path="/"><AppShell /></Route>
          </Switch>
          <CssBaseline />
        </Themeify>
      </Router>
    </div>
  )
}
